import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Download } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-12 px-4 bg-white" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <div className="bg-[#1e3a5f] rounded-3xl shadow-2xl overflow-hidden text-white relative" data-id="element-117">
          {/* Header */}
          <div className="bg-[#162a45] p-4 text-center border-b border-white/10" data-id="element-118">
            <h2 className="text-xl font-medium text-blue-200" data-id="element-119">
              Oferta Especial de Lanzamiento
            </h2>
          </div>

          <div className="p-6 md:p-10 flex flex-col md:flex-row items-center gap-8" data-id="element-120">
            {/* Left: Value Stack */}
            <div className="flex-1 space-y-3" data-id="element-121">
              <h3 className="text-2xl font-bold mb-2" data-id="element-122">
                Método Doble Control 4×4
              </h3>
              <p className="text-blue-200 mb-4" data-id="element-123">
                El sistema definitivo para mamás peruanas.
              </p>

              <ul className="space-y-2 text-sm md:text-base" data-id="element-124">
                <li className="flex items-center" data-id="element-125">
                  <ShieldCheck className="h-5 w-5 text-[#e63946] mr-3" data-id="element-126" /> Guía
                  PDF Completa
                </li>
                <li className="flex items-center" data-id="element-127">
                  <ShieldCheck className="h-5 w-5 text-[#e63946] mr-3" data-id="element-128" />{' '}
                  Plantillas de Sobres
                </li>
                <li className="flex items-center" data-id="element-129">
                  <ShieldCheck className="h-5 w-5 text-[#e63946] mr-3" data-id="element-130" />{' '}
                  Tracker Semanal
                </li>
                <li className="flex items-center" data-id="element-131">
                  <ShieldCheck className="h-5 w-5 text-[#e63946] mr-3" data-id="element-132" />{' '}
                  Guiones Anti-Conflicto
                </li>
              </ul>
            </div>

            {/* Right: Price & CTA */}
            <div className="flex-1 w-full text-center md:text-right" data-id="element-133">
              <div className="mb-4" data-id="element-134">
                <span className="text-slate-400 line-through text-lg block" data-id="element-135">
                  Precio Regular S/ 69
                </span>
                <span className="text-5xl font-bold text-white tracking-tight" data-id="element-136">
                  S/ 21.19
                </span>
                <span className="text-blue-200 block mt-1" data-id="element-137">Pago único</span>
              </div>

              <CTAButton className="w-full text-lg py-4 shadow-xl" href="https://narelaspace.com/cart/47535623340252:1" data-id="element-138">
                Quiero dejar de sobrevivir
              </CTAButton>

              <div className="mt-3 flex items-center justify-center md:justify-end text-xs text-blue-300" data-id="element-139">
                <Download className="h-3 w-3 mr-1" data-id="element-140" />
                Entrega inmediata a tu correo
              </div>
            </div>
          </div>
        </div>

        {/* Final Close */}
        <div className="mt-10 text-center max-w-2xl mx-auto" data-id="element-141">
          <p className="text-lg text-slate-700 mb-4 font-medium" data-id="element-142">
            La última semana del mes no debería sentirse como un castigo.
          </p>
          <p className="text-base text-slate-600 mb-6" data-id="element-143">
            No necesitas convertirte en otra persona. Necesitas un sistema que
            te proteja cuando estás en tu peor día.
          </p>
          <p className="font-bold text-[#1e3a5f] text-base" data-id="element-144">
            Doble Control 4×4 es eso: paredes simples para que tu dinero deje de
            escaparse.
          </p>
        </div>
      </div>
    </section>;
}